import { useEffect } from "react";
import type { BrandConfig } from "../lib/kiosk-client";
import { applyBrandConfig } from "../lib/theme";

interface Props {
  config: BrandConfig;
}

export function KioskBrand({ config }: Props) {
  useEffect(() => {
    applyBrandConfig(config);
  }, [config]);
  return null;
}
